import { SetRoleAndPermissions } from "../../../../types/permissions/permissionRoleInterface";
import api from "../../../../lib/api";

export const getPermissionRoleListApi = async (data: number) => {
  return await api.get(`role-permission/department`, {
    params: {
      department: data
    }
  });
};

export const setPermissionInRoleApi = async (data: SetRoleAndPermissions[]) => {
  return await api.post(`role-permission`, data);
};